import React, { useEffect, useState, useContext } from 'react'
import './single.scss'
import Sidebar from '../../../components/sidebar/Sidebar'
import Navbar from '../../../components/navbar/Navbar'
// import Chart from '../../../components/chart/Chart'
import { doc, getDoc, onSnapshot, collection, query, where, getDocs, updateDoc } from "firebase/firestore"
import {  Link, useParams } from "react-router-dom"
import { db } from '../../../firebase'
import Switch from '@mui/material/Switch';
import img from '../../../assets/images/user.png'
import ConfirmStatusBox from '../../../components/ConfirmStatusBox'
import Typography from '@mui/material/Typography';
import Breadcrumbs from '@mui/material/Breadcrumbs';
// import UserOrderTable from '../../../components/table/Use
import ConfirmBox from '../../../components/ConfirmBox';
import commentorPhoto from '../../../assets/images/user.png'

import outlet from '../../../assets/images/outlet-2.png'

import { AuthContext } from '../../../context/AuthContext'


const Single = ({user}) => {

  const {rewardId} = useParams()

  
    const [isloading, setIsloading ] = useState(false)
  
    const today = new Date().toDateString()
  
    const [title, setTitle] = useState("")
  
    const [description, setDescription] = useState("")
  
    const [coin, setCoin] = useState("")
  
    const [price, setPrice] = useState("")
  
    const [imgactive, setImgactive] = useState("")
  
    const [imginactive, setImginactive] = useState("")
  
    const [status, setStatus] = useState("active")
  
    const [redeemStatus, setRedeemStatus] = useState(false)
  
    const [externalStatus, setExternalStatus] = useState(false)
  
    const [width, setWidth] = useState("")
  
    const [height, setHeight] = useState("")
  
    const [createdAt, setCreatedAt] = useState(new Date())
  
    const [ perc, setPerc ] = useState(null)
    
    const [activefile, setactivefile ] = useState("")
  
    const [inactivefile, setinactivefile ] = useState("")
  
    const [rewardImage, setRewardImage] = useState("")
  
    const [errorTitle, setErrorTitle] = useState(false)
  
    const [errorDescription, setErrorDescription] = useState(false)
  
    const [errorCoin, setErrorCoin] = useState(false)
  
    const [errorPrice, setErrorPrice] = useState(false)
  
    const [errorWidth, setErrorWidth] = useState(false)
  
    const [errorHeight, setErrorHeight] = useState(false)






  const [ rewardData, setRewardData ] = useState("")

  const [ userData, setUserData ] = useState([])

  const [ review, setReview] = useState([])

  const [accountUser, setAccountUser] = useState(false) 

  const [checked, setChecked] = React.useState(true);

  const [photos, setPhotos] = useState([])
 
  const [ openModal, setOpenModal ] = useState(false)

  const [payment, setPayment] = useState([])

  const closeModal = () => setOpenModal(false)

  const [openStatus, setOpenStatus] = useState(false)

  const { currentUser } = useContext(AuthContext)
        
  const userIds = currentUser.uid;


      
  const [adminRole, setAdminRole] = useState("")


      
  const getAdminRole = async() => {
    
    const docRef = doc(db, "admins", userIds);

    const docSnap = await getDoc(docRef);

    
    if (docSnap.exists()) {

      setAdminRole(docSnap.data().role)

    } else {

      console.log("No such document!");
    }
  }


  useEffect(()=>  {

    getAdminRole()

  }, [])
    
  



  const handleChange = (event) => {

    setChecked(event.target.checked);

  };




  useEffect(() => {

    const docRef = doc(db, "loyaltyReward", rewardId);

    const unsubscribe = onSnapshot(docRef, (docSnap) => {

      if (docSnap.exists()) {

        setRewardData({ id: docSnap.id, ...docSnap.data() });

      } else {
        
        setRewardData(null);

      }

    }, (error) => {

      console.error("Error listening to document:", error);

    });

    return () => unsubscribe();

  }, [rewardId]);


  

  // const getAdverts = async() => {

  //     const docRef = doc(db, "adverts", advertId);

  //     const docSnap = await getDoc(docRef);

    
      
  //     if (docSnap.exists()) {

  //       setRewardData(docSnap.data())

  //       setAccountUser(true)

  //       setPhotos(docSnap.data().advertImage)
  //       // console.log(rewardData)
  //     } else {
  //       // doc.data() will be undefined in this case
  //       console.log("No such document!");
  //     }
  // }

  // useEffect(()=>{

  //   getAdverts()

  // }, [])


  //  useEffect(() => {
    
  //   //LISTEN REAL TIME

  //   const reviewQuery = async() => {

  //     const reviewRef = (collection(db, "reviews"));

  //     const q = query(reviewRef, where("subId", "==", subId));

  //     const querySnapshot = await getDocs(q);

  //     let list = []

  //     querySnapshot.forEach((doc) => {
  //       // doc.data() is never undefined for query doc snapshots
  //       list.push(doc.data())
  //       // console.log(doc.id, " => ", doc.data());
  //       console.log(list)

  //       setReview(list)
  //       // console.log(orderData)
  //     });

  //   }
    
  //   reviewQuery()   

  // },[])





const handleModal = (photo) => {

  setOpenModal(true) 

  setPhotos(photo)

}



  const options = {  maximumFractionDigits: 2 }


  const Modal = ({open, close, photo}) => {
     
    if(!open) return null
    return(
     <div style={{
      backgroundColor: 'black',
      widows:'100%',
      height:'100%',
     }}>
       <div style={{

        maxWidth: 600,
        backgroundColor: 'white',
      }}>
       
         <div className="modalRight">
           <p className="closeBtn" onClick={close}>X</p>
           <div></div>

 
         </div>
       </div>
     </div>
    )
}


     const handleStatus = async() => {
    
        
        const rewardRef = doc(db, "loyaltyReward", rewardId);
    
        await updateDoc(rewardRef, {
    
        status: rewardData.status === "active" ? 'inactive' : 'active', 
        
     })
    
      setOpenStatus(false)
    
      }
 

  return (
    <div className='single'>

      <Modal open={openModal} close={closeModal} />

      <Sidebar/>
      <div className='singleContainer'>
        <Navbar/>
          <div className='topContainer'>
            <div className='topLeft'><h1>Single Reward</h1></div>
            
            <div className='topRight'>
            <Breadcrumbs aria-label="breadcrumb">
              <a underline="hover" color="inherit" href="/">
                Home
              </a>
              <a
                underline="hover"
                color="inherit"
                href="/reward"
              >
                Loyalty Reward List
              </a>
              <Typography color="green">Single Reward</Typography>
            </Breadcrumbs>
            </div>
          </div>
        <div className="top">
          <div className="left">
            {/* <div className="editbutton">Edit</div> */}
            <div style={{display: 'flex', flexDirection:'row', alignItems:'center', justifyContent:'space-between'}}>
            <h2 style={{marginLeft:20, marginTop:20, marginBottom:20, color:'#666'}}>{rewardData.title} Reward Information</h2>

            {
              adminRole === "adminAccess"

              ?

                <div style={{display:'flex', flexDirection:'row', gap:10, justifyContent:'center', alignItems:'center', marginRight:100 }}>
                <a onClick={(event)=> {event.preventDefault(); setOpenStatus(true);}}  style={{ border: '1px solid green', borderRadius:'5px', justifyItems:'center', alignItems:'center', textDecoration:'none', paddingTop:'10px', paddingBottom:'10px', paddingRight:'40px', paddingLeft:'40px', backgroundColor:rewardData.status === "active" ? "green" : "red", cursor:'pointer'}}>
                    <span style={{color:'white', fontWeight:'bold'}}>{rewardData.status === "active" ? "Active" : "Inactive"}</span>
                </a>

                 <Link to={`/reward/edit/${rewardId}`} style={{ border: '1px solid blue', borderRadius:'5px', justifyItems:'center', alignItems:'center', textDecoration:'none', paddingTop:'10px', paddingBottom:'10px', paddingRight:'40px', paddingLeft:'40px', backgroundColor:"blue", cursor:'pointer'}}>
                    <span style={{color:'white', fontWeight:'bold'}}>Edit</span>
                </Link>

      

            </div>

            :

            adminRole === "subadminAccess"

            ?

              <div style={{display:'flex', flexDirection:'row', gap:10, justifyContent:'center', alignItems:'center', marginRight:100 }}>
                <a onClick={(event)=> {event.preventDefault(); setOpenStatus(true);}}  style={{ border: '1px solid green', borderRadius:'5px', justifyItems:'center', alignItems:'center', textDecoration:'none', paddingTop:'10px', paddingBottom:'10px', paddingRight:'40px', paddingLeft:'40px', backgroundColor:rewardData.status === "active" ? "green" : "red", cursor:'pointer'}}>
                    <span style={{color:'white', fontWeight:'bold'}}>{rewardData.status === "active" ? "Active" : "Inactive"}</span>
                </a>

                 <Link to={`/reward/edit/${rewardId}`} style={{ border: '1px solid blue', borderRadius:'5px', justifyItems:'center', alignItems:'center', textDecoration:'none', paddingTop:'10px', paddingBottom:'10px', paddingRight:'40px', paddingLeft:'40px', backgroundColor:"blue", cursor:'pointer'}}>
                    <span style={{color:'white', fontWeight:'bold'}}>Edit</span>
                </Link>

      

            </div>

            :

            ""



            }


            </div>
            <div className='item'>
              
                <div className="details">
               
                  <div className='detailItem'>
                    <span className='itemKey'>Reward Title:</span>
                    <span className='itemValue'>{rewardData.title}</span>
                  </div>
                  <div className='detailItem' style={{width:420}}>
                    <span className='itemKey'>Reward Description:</span>
                    <span className='itemValue'>{rewardData.description}</span>
                  </div>
                  <div className='detailItem'>
                    <span className='itemKey'>Date Created:</span>
                    <span className='itemValue'>{rewardData.createdAt}</span>
                  </div>
                  <div className='detailItem'>
                    <span className='itemKey'>Status:</span>
                    <span className='itemValue'>{rewardData.status}</span>
                  </div>
                </div>


                <div className="details" style={{width:320}}>
                  {/* <h3 className='itemTitle'></h3> */}
                  <div className='detailItem'>
                    <span className='itemKey'>Coin:</span>
                    <span className='itemValue'>{rewardData.coin}</span>
                  </div>
                  <div className='detailItem'>
                    <span className='itemKey'>Actual Reward Price:</span>
                    <span className='itemValue'>
                      <img
                        src='../images/naira.png'
                        alt=""
                        // className='imgs'
                        style={{width:12, height:15, cursor:'pointer', marginTop:10, paddingTop:10}}
                        resizeMode = "contain"
                      />
                       {rewardData.price}
                    </span>
                  </div>
                  <div className='detailItem'>
                    <span className='itemKey'>Image Width:</span>
                    <span className='itemValue'>{rewardData.width}</span>
                  </div>
                  <div className='detailItem'>
                    <span className='itemKey'>Image Height:</span>
                    <span className='itemValue'>{rewardData.height}</span>
                  </div>

                </div>



                <div className="details">
                  {/* <h3 className='itemTitle'></h3> */}
                  <div className='detailItem'>
                    <span className='itemKey'>Redeem Status:</span>
                    <span className='itemValue'>{rewardData.redeemStatus}</span>
                  </div>
                  <div className='detailItem'>
                    <span className='itemKey'>External Status:</span>
                    <span className='itemValue'>{rewardData.externalStatus}</span>
                  </div>
             
                 
                </div>

              

            </div>
          </div>
          
        </div>
        
        
      
        <div className="bottom">

             <img
                    
              src = {rewardData.imgactive}
              alt="avatar"
              style={{width:'45%', height:'45%', borderRadius:10}}
            
            /> 

              <img
                    
              src = {rewardData.imginactive}
              alt="avatar"
              style={{width:'45%', height:'45%', borderRadius:10}}
            
            /> 
      
        </div>

        <ConfirmStatusBox
          openStatus={openStatus}
          closeDialog={() => setOpenStatus(false)}
          statusFunction={handleStatus }
        />



      </div>
    </div>
  )
}

export default Single